import { FC } from 'react'
import { BadgeName } from 'src/app/types'
import BadgeSVG from 'src/components/BadgeSVG/BadgeSVG'

type BadgeSelectProps = {
  badges: BadgeName[]
  onClickBadge: (arg: BadgeName) => void
}

const BadgeSelect: FC<BadgeSelectProps> = ({ badges, onClickBadge }) => {
  return (
    <div className="inline-flex rounded-lg bg-white shadow-tooltip border-borderGrey border-[0.5px] px-4 py-2">
      {badges.map((name) => (
        <button
          key={name}
          aria-label={`${name} badge`}
          className="[&:not(:last-child)]:mr-3"
          onClick={() => onClickBadge(name)}
        >
          <BadgeSVG name={name} />
        </button>
      ))}
    </div>
  )
}

export default BadgeSelect
